import React, {  useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import useStyles from "../../styles";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { instructionField } from "Recoil/CompanySetup/selector";
import { instructionKeys } from "src/constants/instructionKeys";
import { Typography } from "@material-ui/core";

const PasswordComplexityMessage = () => {
  const { t } = useTranslation();
  // const {
  //   register,
  //   control,
  //   formState: { errors },

  //   watch
  // } = useFormContext();
  const classes = useStyles();
  const { passwordComplexity } = useWatch({ name: `configuration` });
  const _setInstructionField = useSetRecoilState(instructionField);

  const { companySetup } = instructionKeys;
  const htmlText = useRecoilValue(instructionField);
  useEffect(() => {
    _setInstructionField(companySetup.config.passwordComplexity);
  }, [_setInstructionField]);

  const index = {
    HIGH: 0,
    MEDIUM: 1,
    LOW: 2
  };

  return (
    <Typography className={classes.passwordList}>
      <div
        className={classes.formHint}
        dangerouslySetInnerHTML={{
          __html: htmlText
            ? htmlText
              .split("p>")
              .filter(str1 => str1.startsWith("<ul"))
              .map(str => str.substring(0, str.lastIndexOf("<")))[
            index[passwordComplexity]
            ]
            : ""
        }}
      />
    </Typography>
  );
};

export default PasswordComplexityMessage;
